var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import Roster from '@/components/roster/Roster';
import NotificationsCard from '@/components/notifications-card/NotificationsCard';
import { Group } from '@/models/Group';
import DataTable from '@/components/data-table/DataTable';
import { Student } from '@/models/Student';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
import GoalPlanner from '@/views/Groups/Tabs/GoalPlanner/GoalPlanner.vue';
import { RolesEnum } from '@/items/Roles';
import { getAge } from '@/support/Age';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import StudentSelect from '@/components/StudentSelect/StudentSelect.vue';
let AStudentTable = class AStudentTable extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.selectedUsers = [];
        this.selectedStudents = [];
        this.RolesEnum = RolesEnum;
        this.selectedStudentId = '';
        this.isEditingTreatment = false;
        // #endregion
    }
    // #region Lifecycle hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        // await this.fetchUser();
        // await this.fetchGroup();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onTableInput(value) {
        this.selectedStudents = value;
        this.$emit('update:selectedStudents', this.selectedStudents);
    }
    // #endregion
    // #region Class methods
    getUserAge(dob) {
        return getAge(dob) || '-';
    }
    onClickOpenTreatmentDialog(userId) {
        this.selectedStudentId = userId;
        this.isEditingTreatment = true;
    }
    handleTreatmentSaved() {
        const studentListTable = this.$refs.studentListTable;
        if (studentListTable) {
            studentListTable.refresh();
        }
        this.isEditingTreatment = false;
    }
    clearSelectedStudents() {
        this.selectedStudents = [];
        const studentListTable = this.$refs.studentListTable;
        if (studentListTable) {
            studentListTable.clearSelected();
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters
    get hasSelectedStudents() {
        return this.selectedStudents.length > 0;
    }
    get hasSelectedUsers() {
        return this.selectedStudents.length > 0;
    }
    get tableOptions() {
        const options = {
            name: {
                singular: this.$tc('Student'),
                plural: this.$tc('Students'),
            },
            model: new Student()
                .include('treatment_labels')
                .filter({ group: this.group ? this.group.id : null, ids: this.selectedUsers }),
            headers: [
                // { text: '', value: '' },
                { text: this.$t('name.title'), value: 'name' },
                { text: this.$t('Age'), value: 'dob', slot: 'age' },
                { text: '', value: 'treatment', slot: 'treatment' },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    visible: (vm, student) => {
                        return true;
                    },
                    action: (vm, student) => {
                        if (!student || !student.id) {
                            return;
                        }
                        this.$router.push({
                            path: `/students/${student.id}`,
                        });
                    },
                },
            ],
            dropdown: [],
            filters: [],
        };
        if (this.showTableTitle) {
            return {
                ...options,
                title: this.$tc('Students'),
            };
        }
        return options;
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], AStudentTable.prototype, "group", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AStudentTable.prototype, "showCheckboxes", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AStudentTable.prototype, "showFilters", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AStudentTable.prototype, "showTableTitle", void 0);
AStudentTable = __decorate([
    Component({
        components: {
            DataTable,
            TreatmentDialog,
            NotificationsCard,
            Roster,
            AQuillEditor,
            GoalPlanner,
            StudentSelect,
        },
    })
], AStudentTable);
export default AStudentTable;
